/**
 * Playground interceptor handlers for Dashboard and Portfolio data.
 * Matches API patterns: /v1/web/dashboards, /v1/web/user-game,
 * /v1/web/game-ecosystem, /v1/web/live-services-homepage
 */
import { PlaygroundSessionStore, PlaygroundLimitError } from '../PlaygroundSessionStore.js';

const gamesStore = new PlaygroundSessionStore('pg_games', 5);

// Hardcoded portfolio metrics
const portfolioMetrics = [
    { id: 'metric-1', name: 'Total DAU', value: '3.98M', trend: 'up', change: '+6.2%' },
    { id: 'metric-2', name: 'Portfolio Revenue', value: '$2.81M', trend: 'up', change: '+11.8%' },
    { id: 'metric-3', name: 'Avg ARPU', value: '$0.71', trend: 'up', change: '+3.1%' },
    { id: 'metric-4', name: 'Active Games', value: '3', trend: 'neutral', change: '0' },
    { id: 'metric-5', name: 'Avg D1 Retention', value: '42%', trend: 'up', change: '+2.1%' },
    { id: 'metric-6', name: 'Avg Session Length', value: '22 min', trend: 'up', change: '+4.7%' },
];

/**
 * Read portfolio games from sessionStorage.
 */
function getPortfolioGames() {
    try {
        const raw = sessionStorage.getItem('pg_portfolio_games');
        return raw ? JSON.parse(raw) : [];
    } catch {
        return [];
    }
}

/**
 * GET /v1/web/dashboards/user/layout - return the mock user dashboard layout with metrics.
 */
export function handleGetPortfolio(config, match) {
    const games = getPortfolioGames();
    return {
        metrics: portfolioMetrics,
        games,
    };
}

/**
 * GET /v1/web/user-game - return all games (same as pg_games).
 */
export function handleGetUserGames(config, match) {
    return gamesStore.getAll();
}

/**
 * GET /v1/web/game-ecosystem/companies/:orgId - return org info.
 */
export function handleGetCompanyByOrgId(config, match) {
    const orgId = match[1];
    return {
        name: 'Playground Studio',
        orgId: orgId || 'pg-org-001',
    };
}

/**
 * GET /v1/web/game-ecosystem/company-games - return all games.
 */
export function handleGetCompanyGames(config, match) {
    return gamesStore.getAll();
}

/**
 * GET /v1/web/live-services-homepage - return mock live services summary.
 */
export function handleGetLiveServicesHomepage(config, match) {
    const remoteConfigs = (() => {
        try {
            const raw = sessionStorage.getItem('pg_remote_configs');
            return raw ? JSON.parse(raw) : [];
        } catch {
            return [];
        }
    })();

    const abTests = (() => {
        try {
            const raw = sessionStorage.getItem('pg_ab_tests');
            return raw ? JSON.parse(raw) : [];
        } catch {
            return [];
        }
    })();

    const segments = (() => {
        try {
            const raw = sessionStorage.getItem('pg_segments');
            return raw ? JSON.parse(raw) : [];
        } catch {
            return [];
        }
    })();

    return {
        summary: {
            totalRemoteConfigs: remoteConfigs.length,
            activeRemoteConfigs: remoteConfigs.filter(rc => rc.state === 'ACTIVE').length,
            totalAbTests: abTests.length,
            activeAbTests: abTests.filter(ab => ab.state === 'ACTIVE').length,
            totalSegments: segments.length,
            activeSegments: segments.filter(seg => seg.state === 'active').length,
        },
        recentActivity: [
            { type: 'remote-config', action: 'created', name: 'Welcome to Arena', timestamp: new Date(Date.now() - 86400000).toISOString() },
            { type: 'ab-test', action: 'activated', name: 'First-Time User Experience', timestamp: new Date(Date.now() - 172800000).toISOString() },
            { type: 'segment', action: 'updated', name: 'High Spenders', timestamp: new Date(Date.now() - 259200000).toISOString() },
        ],
    };
}
